export default __webpack_public_path__ + "assets/images/094f52d3c02dc673c252b74c6cd57156.svg";